import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.4 12a.9.9 0 0 1-.9.9H6.734l4.99 4.751a.9.9 0 0 1-1.248 1.298l-6.6-6.3a.9.9 0 0 1 0-1.298l6.6-6.3a.9.9 0 1 1 1.248 1.298L6.734 11.1H19.5a.9.9 0 0 1 .9.9"
    }, null, -1)
  ])))
}
export default { render: render }